import { injectable } from 'inversify';
import { Observable, Subject, filter } from 'rxjs';
import { BrowserBroadcast, TabMessagesDict, TabMessagesLabels, TabsEvent } from './browserBroadcast';

@injectable()
export class InmemoryBrowserBroadcast implements BrowserBroadcast {
  private obs$ = new Subject<TabsEvent<TabMessagesLabels>>();

  publish(message: TabsEvent<keyof TabMessagesDict>): void {
    this.obs$.next(message);
  }

  getMessageFromLabel<TLabel extends keyof TabMessagesDict>(label: TLabel): Observable<TabsEvent<TLabel>> {
    return this.obs$.pipe(filter((message) => message.label === label)) as Observable<TabsEvent<TLabel>>;
  }
}
